import { Button } from "@cmsgov/ds-medicare-gov";
import classNames from "classnames";
import React, { FC, useContext, Dispatch, SetStateAction } from "react";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
  Ga4Event,
} from "../../../app/contexts/Analytics/types";
import { AppContext } from "../../../app/store";

interface MoreBenefitsSectionProps {
  buttonTextToCollapse: string;
  buttonTextToOpen: string;
  isOpen: boolean;
  section: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const MoreBenefitsSection: FC<MoreBenefitsSectionProps> = ({
  buttonTextToCollapse,
  buttonTextToOpen,
  children,
  isOpen,
  section,
  setIsOpen,
}) => {
  const { dispatch } = useContext(AppContext);
  return (
    <>
      <Button
        isAlternate
        variation="solid"
        className="ds-l-col--12 ds-u-margin-top--4 ds-u-padding-y--3 mct-hide-print"
        onClick={() => {
          setIsOpen(!isOpen);
          dispatch({
            type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
            settings: {
              button: {
                buttonStyle: AnalyticsButtonStyle.SECONDARY,
                buttonType: AnalyticsButtonType.BUTTON,
                text: isOpen ? buttonTextToCollapse : buttonTextToOpen,
              },
            },
          });
          if (!isOpen) {
            dispatch({
              type: AnalyticsActionType.SEND_TEALIUM_EVENT,
              settings: {
                event_action: "Plan Details view more",
                event_label: `${section}|expand`,
              },
            });
            dispatch({
              type: AnalyticsActionType.SEND_GA4_EVENT,
              settings: {
                event_name: Ga4Event.PLAN_DETAILS_VIEW_MORE_EXPANDED,
                click_text: buttonTextToOpen,
              },
            });
          } else {
            dispatch({
              type: AnalyticsActionType.SEND_TEALIUM_EVENT,
              settings: {
                event_action: "Plan Details view more",
                event_label: `${section}|close`,
              },
            });
            dispatch({
              type: AnalyticsActionType.SEND_GA4_EVENT,
              settings: {
                event_name: Ga4Event.PLAN_DETAILS_VIEW_MORE_CLOSED,
                click_text: buttonTextToCollapse,
              },
            });
          }
        }}
        aria-expanded={isOpen}
      >
        <i
          className={classNames(
            "ds-u-margin-right--1 fas",
            { "fa-plus": !isOpen },
            { "fa-minus": isOpen }
          )}
        />
        {isOpen ? buttonTextToCollapse : buttonTextToOpen}
      </Button>
      <div
        className={classNames(
          "PlanDetailsSection__collapse-container",
          isOpen
            ? "PlanDetailsSection__collapse-container--expanded"
            : "PlanDetailsSection__collapse-container--collapsed"
        )}
        aria-hidden={!isOpen}
      >
        {children}
      </div>
    </>
  );
};
